<template>
  <div
    class="c-header"
    :style="{
      'background-image':
        'url(' +
        require('@arag/assets/img/slider/slider_medical_contact.svg') +
        ')',
    }"
  >
    <img src="@arag/assets/img/medicalcontact_logo.png" width="240" />
    <div class="c-header__text">
      Ihr persönlicher Coach bei Diabetes II oder Herzerkrankungen.
    </div>
  </div>
  <p>
    <b
      >Sie erhalten wertvolle Unterstützung für den richtigen Umgang mit Ihrer
      Erkrankung und zu gesundheitsfördernden Maßnahmen.
    </b>
  </p>
  <p>
    Verbessern Sie Ihre Lebensqualität!<br />
    Mit konkreten Tipps zu Ernährung, körperlicher Aktivität und der Vorbeugung
    von Folgeerkrankungen. Bei Bedarf werden medizinische Hilfsmittel wie
    Schrittzähler, Blutzucker- oder Blutdruckmessgerät zur Verfügung gestellt –
    für Sie kostenlos.
  </p>
  <ion-button
    size="small"
    fill="clear"
    class="ion-text-wrap ion-no-padding"
    @click="openKostenerstattungModal"
    >Kostenlos für ARAG-Kunden mit Vollversicherung!&nbsp;
    <ion-icon :icon="helpCircle" />
  </ion-button>
</template>

<script>
import { modalController, IonButton, IonIcon } from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
import KostenerstattungModal from "@arag/components/KostenerstattungMedicalContactModal";

export default {
  components: {
    IonButton,
    IonIcon,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
    };
  },
};
</script>

<style></style>
